<template>
  <div class="situation">
    <div class="title">
      <el-button
        class="back-btn"
        type="text"
        icon="el-icon-arrow-left"
        @click="$router.go(-1)"
        >返回</el-button
      >
      <b>知识考核</b>
      <div class="export_btn">导出数据 <i class="el-icon-arrow-right"></i></div>
    </div>
    <div class="main">
      <div class="main_title">
        <span>{{ mainTitle }}</span>
        <span style="margin-left: 15px">( {{ studentList.length }}人 )</span>
        <span style="margin: 0 30px 0 220px; color: #fff">各选项选择率</span>
        <span
          v-for="item in rate"
          :key="item.tag"
          style="margin-right: 15px; color: #fff"
          >{{ item.tag }}：{{ item.per }}%</span
        >
      </div>
      <div class="student_list">
        <div class="list_title">
          <span>序号</span>
          <span>姓名</span>
          <span>性别</span>
          <span>学号</span>
          <span>团队</span>
          <span>岗位</span>
          <span>所选答案</span>
          <span>完成时间</span>
        </div>
        <div class="list_main">
          <div
            class="row"
            v-for="(item, idx) in studentList"
            :key="item.userId"
          >
            <span>{{ idx + 1 }}</span>
            <span>{{ item.nickName }}</span>
            <span>{{ formatSex(item.sex) }}</span>
            <span>{{ item.sno }}</span>
            <span>{{ item.teamName || "无" }}</span>
            <span>{{ item.postName || "无" }}</span>
            <span>{{ item.answers ? item.answers.split(',').sort().join(' ') : "无" }}</span>
            <span>{{
              formatDate(item.createTime, "YYYY-MM-DD HH:MM:SS")
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { userQuestionRate, userQuestionInfo } from "@/api/evaluation";
import { formatDate } from "@/utils/index";

export default {
  name: "situation",
  data() {
    return {
      formatDate,
      studentList: [],
      rate: [],
    };
  },
  created() {
    this.getRate();
    this.getList();
  },
  computed: {
    mainTitle() {
      let type = this.$route.query.type;
      if (type == "right") return "正确人数";
      else if (type == "error") return "错误人数";
      else return "未做人数";
    },
  },
  methods: {
    //考题目选项选择率
    getRate() {
      userQuestionRate({
        classId: this.$route.query.id,
        questionId: this.$route.query.questionId,
      }).then((res) => {
        if (res.code == 0) {
          for (let i in res.data) {
            let o = {};
            o.tag = i;
            o.per = res.data[i];
            this.rate.push(o);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getList() {
      this.$loading.show();
      userQuestionInfo({
        classId: this.$route.query.id,
        questionId: this.$route.query.questionId,
        type: this.$route.query.type,
      }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.studentList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    formatSex(string) {
      if (string == "MAN") return "男";
      else if (string == "WOMAN") return "女";
      else return "未知";
    },
  },
};
</script>

<style lang="less" scoped>
.situation {
  height: 748px;
  background-image: url("../../../../assets/images/evaluation_bg.png");
  background-size: cover;
  .title {
    position: relative;
    padding-top: 40px;
    height: 105px;
    text-align: center;
    background-image: url("../../../../assets/images/title_bg1.png");
    background-size: cover;
    .back-btn {
      position: absolute;
      left: 20px;
      top: 13px;
    }

    b {
      letter-spacing: 5px;
      font-size: 30px;
      color: transparent;
      background-image: linear-gradient(180deg, #fff, #fff, #1de0fe, #1de0fe);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .export_btn {
      position: absolute;
      top: 62px;
      right: 0;
      width: 114px;
      height: 32px;
      line-height: 32px;
      color: #fff;
      background-image: url("../../../../assets/images/btn_bg.png");
      cursor: pointer;
    }
  }
  .main {
    margin: 20px 2px 0;
    .main_title {
      padding: 0 32px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: #1de0fe;
      text-align: left;
      background-color: rgba(49, 70, 125, 0.1);
      // border: solid 1px rgba(4, 20, 40, 0.1);
      box-shadow: #6be4f7 0px 0px 5px inset;
    }
    .student_list {
      .list_title {
        padding: 0 32px;
        height: 40px;
        line-height: 40px;
        color: #1de0fe;
        text-align: left;
        background-color: rgba(82, 255, 255, 0.2);
        span {
          display: inline-block;
          text-align: center;
          &:first-child {
            width: 50px;
          }
          &:nth-child(2) {
            width: 140px;
          }
          &:nth-child(3) {
            width: 60px;
          }
          &:nth-child(4) {
            width: 160px;
          }
          &:nth-child(5) {
            width: 250px;
          }
          &:nth-child(6) {
            width: 160px;
          }
          &:nth-child(7) {
            width: 100px;
          }
          &:nth-child(8) {
            width: 210px;
          }
        }
      }
      .list_main {
        padding: 0 30px 0 32px;
        height: calc(748px - 40px - 48px - 20px - 105px);
        overflow-y: auto;
        &::-webkit-scrollbar {
          width: 6px;
          background-color: rgb(14, 88, 113);
        }

        &::-webkit-scrollbar-track {
          box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
          -webkit-box-shadow: inset 0 0 6px rgba(14, 88, 113, 0.3);
          background-color: rgb(14, 88, 113);
        }

        &::-webkit-scrollbar-thumb {
          box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
          -webkit-box-shadow: inset 0 0 6px rgba(27, 213, 246, 0.1);
          background-color: #1ae0fe;
        }
        .row {
          padding: 15px 0 6px;
          line-height: 1;
          text-align: left;
          color: #feffff;
          border-bottom: solid 1px transparent;
          border-image: linear-gradient(to right, #1de0fe, transparent) 1 10;
          span {
            display: inline-block;
            text-align: center;
            &:first-child {
              width: 50px;
            }
            &:nth-child(2) {
              width: 140px;
            }
            &:nth-child(3) {
              width: 60px;
            }
            &:nth-child(4) {
              width: 160px;
            }
            &:nth-child(5) {
              width: 250px;
            }
            &:nth-child(6) {
              width: 160px;
            }
            &:nth-child(7) {
              width: 100px;
            }
            &:nth-child(8) {
              width: 200px;
            }
          }
        }
      }
    }
  }
}
</style>